import { useCallback } from 'react';

import { useSellerOnboardingVariant } from '../../../hooks/use-seller-setting';
import { Segment } from '../../../services/analytics-services/segment';

export const useSegmentTracking = (event, data = {}) => {
  const onboardingVariant = useSellerOnboardingVariant();
  return useCallback(() => {
    const params = {
      onboardingVariant,
      ...data,
    };
    setTimeout(() => Segment.trackEvent(event, params), 0);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [event, onboardingVariant]);
};
